/* Adds a per-card mute/unmute toggle to the inline hfrs reels strip on the PDP.
   The cards are <button class="hfrs__card"> containing a muted <video data-hfrs-inline>.
   This injects a small speaker toggle top-right of each card without opening the modal. */
(function () {
  function init() {
    var cards = document.querySelectorAll('.hfrs__card');
    if (!cards.length) return;

    if (!document.getElementById('hfrs-cardmute-css')) {
      var st = document.createElement('style');
      st.id = 'hfrs-cardmute-css';
      st.textContent =
        '.hfrs__card{position:relative}' +
        '.hfrs__cm{position:absolute;top:8px;right:8px;z-index:6;width:30px;height:30px;border:0;border-radius:50%;' +
        'background:rgba(0,0,0,.5);display:flex;align-items:center;justify-content:center;cursor:pointer;padding:0;' +
        'backdrop-filter:blur(3px);-webkit-backdrop-filter:blur(3px)}' +
        '.hfrs__cm svg{width:16px;height:16px;display:block}' +
        '.hfrs__cm .cm-on{display:none}' +
        '.hfrs__cm.is-unmuted .cm-on{display:block}' +
        '.hfrs__cm.is-unmuted .cm-off{display:none}';
      document.head.appendChild(st);
    }

    var SVG_OFF =
      '<svg class="cm-off" viewBox="0 0 24 24" fill="#fff" aria-hidden="true">' +
      '<path d="M3 9v6h4l5 5V4L7 9H3z"/><line x1="16" y1="8" x2="22" y2="14" stroke="#fff" stroke-width="2" stroke-linecap="round"/>' +
      '<line x1="22" y1="8" x2="16" y2="14" stroke="#fff" stroke-width="2" stroke-linecap="round"/></svg>';
    var SVG_ON =
      '<svg class="cm-on" viewBox="0 0 24 24" fill="#fff" aria-hidden="true">' +
      '<path d="M3 9v6h4l5 5V4L7 9H3zm11.5 3a4.5 4.5 0 0 0-2.5-4v8a4.5 4.5 0 0 0 2.5-4zM14 3.23v2.06a7 7 0 0 1 0 13.42v2.06a9 9 0 0 0 0-17.54z"/></svg>';

    Array.prototype.forEach.call(cards, function (card) {
      if (card.dataset.cmReady) return;
      card.dataset.cmReady = '1';
      var vid = card.querySelector('[data-hfrs-inline]');
      if (!vid) return;

      var btn = document.createElement('span');
      btn.className = 'hfrs__cm';
      btn.setAttribute('role', 'button');
      btn.setAttribute('tabindex', '0');
      btn.setAttribute('aria-label', 'Toggle sound');
      btn.innerHTML = SVG_OFF + SVG_ON;

      function sync() { btn.classList.toggle('is-unmuted', !vid.muted); }
      sync();

      function toggle(e) {
        e.preventDefault();
        e.stopPropagation();
        vid.muted = !vid.muted;
        if (!vid.muted) { vid.play().catch(function () {}); }
        sync();
      }
      btn.addEventListener('click', toggle);
      btn.addEventListener('pointerdown', function (e) { e.stopPropagation(); });
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') toggle(e);
      });
      vid.addEventListener('volumechange', sync);

      card.appendChild(btn);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Safety retry in case cards mount slightly later.
  setTimeout(init, 800);
})();
